export class Defaultcase {
    Id                                           :number; 
    SavingsId                                    :number; 
    DefaultCaseDate                              :string; 
    IsDefaultCase                                :boolean;
    IsDefaultDemandStop                          :boolean;
    
    EmployeeId                                   :number; 
    EmployeeBranchId                             :number; 
    CompanyId                                    :number; 
    SaasId                                       :number;  
    IsActive                                     :boolean; 
    Flag                                         :number;
    ToDate                                       :string
}
